import { Component, Input } from '@angular/core';
import { provideTranslocoScope } from '@ngneat/transloco';
import { Store } from '@ngxs/store';
import { BusinessModel, PricingInformation } from '@platform-frontend/marketplace';
import { Observable } from 'rxjs';
import { CHECKOUT_TRANSLOCO_SCOPE } from '../../checkout-transloco-scope';
import { ProductState } from '../../product';

@Component({
  selector: 'yat-price-overview',
  templateUrl: './price-overview.component.html',
  styleUrls: ['./price-overview.component.scss'],
  providers: [provideTranslocoScope(CHECKOUT_TRANSLOCO_SCOPE)]
})
export class PriceOverviewComponent {
  constructor(private store: Store) {}

  @Input()
  pricingInformation: PricingInformation | 'LOADING' | null = null;

  @Input()
  hideTooltip: boolean | null = false;

  businessModel$: Observable<BusinessModel | null> = this.store.select(ProductState.businessModel);
}
